<template>
  <v-tabs class="mb-5" color="primary" slider-color="blue-darken-3">
    <v-tab :to="{ name: 'audit-general-info' }" replace>Основне</v-tab>
    <v-tab :to="{ name: 'audit-flaws' }" replace>
      <span class="mr-2">Факти недоліків</span>
      <v-chip
        color="yellow-darken-4"
        density="compact"
        rounded="lg"
        size="small">
        <span class="font-weight-bold">{{ audit.flaws?.length }}</span>
      </v-chip>
    </v-tab>
    <v-tab :to="{ name: 'audit-attachments' }" replace>
      <span class="mr-2">Вкладення</span>
      <v-chip color="grey-darken-2" density="compact" rounded="lg" size="small">
        <span class="font-weight-bold">{{
          [
            audit.auditProgram,
            audit.auditReport,
            audit.auditAnnouncement,
            audit.otherDocuments,
          ].filter(Boolean).length
        }}</span>
      </v-chip>
    </v-tab>
    <v-tab :to="{ name: 'audit-history' }" replace>Історія змін</v-tab>
  </v-tabs>
</template>

<script lang="ts">
import { useAudit } from '@/pages/audit/audit/single'

export default {
  name: 'AuditTabs',
  setup() {
    return {
      ...useAudit(),
    }
  },
}
</script>

<style lang="scss" scoped></style>
